module.exports = __webpack_public_path__ + "static/media/no-like.9f1508e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/FM/no-like.png
// module id = 530
// module chunks = 1